import { useAuth } from "@/contexts/AuthContext";

/**
 * @deprecated Use useAuth() from AuthContext directly for better performance.
 * This hook is kept for backward compatibility.
 */
export const useAuthSession = () => {
  return useAuth();
};
